export const DATE_RANGES = [
  { label: '24h', value: '24h', days: 1 },
  { label: '3 jours', value: '3d', days: 3 },
  { label: '7 jours', value: '7d', days: 7 },
  { label: '30 jours', value: '30d', days: 30 },
  { label: '90 jours', value: '90d', days: 90 },
  { label: 'Tout', value: 'all', days: null },
];

export const daysForRange = (range) => DATE_RANGES.find((r) => r.value === range)?.days ?? null;

export const isBlank = (v) => !v || ['null', 'not found', 'undefined'].includes(String(v).trim().toLowerCase()) || !String(v).trim();

export function formatDate(date) {
  if (!date) return '—';
  const d = new Date(date);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('fr-FR');
}

export function formatScore(score) {
  return typeof score === 'number' && !Number.isNaN(score) ? `${score.toFixed(1)}/10` : '—';
}

export function scoreColors(score) {
  if (typeof score !== 'number' || Number.isNaN(score)) return { bg: '#f1f5f9', color: '#64748b' };
  if (score >= 7) return { bg: '#f0fdf4', color: '#16a34a' };
  if (score >= 4) return { bg: '#fffbeb', color: '#b45309' };
  return { bg: '#fef2f2', color: '#dc2626' };
}

export const asArray = (v) => (Array.isArray(v) ? v.filter(Boolean) : []);

export function formatUrl(value, domain) {
  if (isBlank(value)) return null;
  const v = String(value).trim();
  if (v.startsWith('http://') || v.startsWith('https://')) return v;
  if (v.startsWith('/')) return `https://${domain}.com${v}`;
  return `https://${v}`;
}

export const initials = (name) =>
  String(name || '?')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0])
    .join('')
    .toUpperCase() || '?';

export const linkedinUrl = (c) => c?.linkedin_verified_url || formatUrl(c?.linkedin, 'linkedin');
